import React from 'react';
import classNames from 'classnames';

import './Spinner.scss';

export enum SpinnerSize {
  FullPage,
  FullComponent,
  Large,
  Normal,
  Small,
}

export type SpinnerProps = {
  size: SpinnerSize;
  className?: string;
  loadingText?: string;
  cover?: boolean;
};

export default function Spinner(props: SpinnerProps) {
  return (
    <div
      className={classNames(
        'loading-spinner component',
        {
          'full-page': props.size === SpinnerSize.FullPage,
          overlay:
            props.size === SpinnerSize.FullComponent ||
            props.size == SpinnerSize.FullPage,
          cover: props.cover,
        },
        props.className
      )}
    >
      <span
        className={classNames('spinner', {
          large: props.size === SpinnerSize.Large,
          small: props.size === SpinnerSize.Small,
        })}
      ></span>
      {props.loadingText ? (
        <span className="loading-text">{props.loadingText}</span>
      ) : null}
    </div>
  );
}
